import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common';
import { media } from '@/styles/theme';

const ContractsRequirementsSkeleton = (): React.ReactElement => (
  <>
    <SkeletonContent />
    <SkeletonPagination />
  </>
);

export { ContractsRequirementsSkeleton };

const SkeletonContent = styled(SkeletonBlock)`
  height: 415px;
  margin-bottom: 8px;

  ${media.tablet} {
    margin-bottom: 16px;
  }
`;

const SkeletonPagination = styled(SkeletonBlock)`
  height: 34px;
  margin-bottom: 12px;

  ${media.phone} {
    height: 46px;
  }

  ${media.tablet} {
    margin-left: auto;
    width: 190px;
  }
`;
